import { render } from "./copyright.vue?vue&type=template&id=612b2e03&scoped=true"
import script from "./copyright.vue?vue&type=script&lang=js"
export * from "./copyright.vue?vue&type=script&lang=js"

import "./copyright.vue?vue&type=style&index=0&id=612b2e03&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612b2e03"]])

export default __exports__